// Meta (Facebook) Pixel helpers for a CRA single-page app.
export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function loadMetaPixel() {
  if (!PIXEL_ID || typeof window === "undefined" || window.fbq) return;

  const n = (window.fbq = function (...args) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export function pageView() {
  if (window.fbq) window.fbq("track", "PageView");
}

// Fire the standard Lead event. eventId must match the server CAPI event_id for dedup.
export function trackLead(eventId) {
  if (window.fbq) window.fbq("track", "Lead", {}, { eventID: eventId });
}

export function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.split("; ").find((x) => x.startsWith(name + "="));
  return match ? match.split("=").slice(1).join("=") : null;
}
